import { getSalesCharts } from "@/api/financialReport";
import { consoleHandlerError, extractErrorMessage } from "@/utils/message";
import { resolveDateRange } from "./utils/dateRange";
import { normalizeSalesCharts } from "./utils/salesCharts";

// Módulo del tab KPIs. A diferencia del resto de los tabs, NO usa el filtro
// global `reportsFilters`: el KpisTab tiene su propio filtro de tiempo local y
// se lo pasa explícito a la action. Así sus consultas no interfieren con las
// del tab Ventas (que comparte chartsData en `salesReport`).

const state = () => ({
    // Mismo shape que salesReport.chartsData (ver utils/salesCharts):
    // { monthHeaders, byClient, clientCounts, avgTickets, hasOtros, topN }.
    chartsData: null,
    isLoading: false,
    error: null,
});

const mutations = {
    SET_CHARTS_DATA(state, payload) {
        state.chartsData = payload;
    },
    SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

const actions = {
    // Fetch de los datos de actividad de clientes (cantidad + ticket promedio)
    // para el rango/granularidad que el tab define localmente. Reusa el mismo
    // endpoint y normalización que los gráficos del header de Ventas.
    async fetchKpisCharts({ commit }, {
        endMonth,
        selectedPeriodRange,
        customRange = null,
        period = "month",
        topN,
    } = {}) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const { initDate, endDate } = resolveDateRange(
                endMonth,
                selectedPeriodRange,
                period,
                customRange,
            );
            const response = await getSalesCharts(initDate, endDate, period, topN);
            commit("SET_CHARTS_DATA", normalizeSalesCharts(response.data, period));
        } catch (error) {
            consoleHandlerError({ error, prefix: "[kpisReport]", silent: true });
            commit("SET_ERROR", extractErrorMessage(error, "Error al cargar los KPIs."));
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
